import * as authApi from "../api/auth";
import { baseUrl } from "../config/api-config";
import {
  auth as actionType,
  handleAxiosError,
} from "../config/action-config.js";
import { showAlert } from "./alert";

export const getUser = (token) => async (dispatch) => {
  try {
    const { data } = await authApi.fetchTokenUser(token);
    dispatch({
      type: actionType.FETCH_SUCCESS,
      payload: { ...data.data, token },
    });
  } catch (error) {
    // handleAxiosError(error);
    // dispatch({
    //   type: actionType.FETCH_FAILURE,
    //   payload: { message: "Please Try Login Again" },
    // });
    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: actionType.LOGOUT, payload: null });
    window.location.reload();
  }
};

export const loginWithEmail =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const { data } = await authApi.emailLogin(email, password);
      if (data.status) {
        if (!data.mfa) {
          localStorage.setItem("token", data.token);
          dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
          window.location.replace(window.location.origin + "/profile");
        } else {
          sessionStorage.setItem("email", data.email);
          window.location.replace(window.location.origin + "/verify-mfa");
        }
      } else {
        dispatch(showAlert(data.msg));
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
      dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
    }
  };

export const logout = () => async (dispatch) => {
  localStorage.removeItem("token");
  dispatch({ type: actionType.LOGOUT, payload: null });
};

export const microsoftLogin = () => (dispatch) => {
  window.location.replace(`${baseUrl}/auth/outlook`);
};

export const microsoftCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.microsoftCallback(query);
    localStorage.setItem("token", data.token);
    dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
  } catch (error) {
    handleAxiosError(error, dispatch);
    dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
  }
};
export const teamsCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.teamsCallback(
      query,
      localStorage.getItem("token")
    );
    console.log(data);
    dispatch({
      type: actionType.UPDATE,
      payload: { msTeamsAuth: data.msTeamsAuth },
    });
    window.location.replace(window.location.origin + "/appraisal");
  } catch (error) {
    dispatch(showAlert("Some Error Occured. Please Try again later."));
  }
};
